// Packages (and therefore most Receipt line items) are always priced in THB
// (see CLAUDE.md pricing section) — `rate` is a CurrencyExchangeRate doc:
// { LAK: <LAK per 1 THB>, USD: <THB per 1 USD> }, same shape the backend
// snapshots onto SalesDocument.exchangeRateSnapshot.
const toTHB = (value, currency, rate) => {
  if (currency === "THB") return value;
  if (currency === "LAK") return value / rate.LAK;
  if (currency === "USD") return value * rate.USD;
  return value;
};

const fromTHB = (thbValue, currency, rate) => {
  if (currency === "THB") return thbValue;
  if (currency === "LAK") return thbValue * rate.LAK;
  if (currency === "USD") return thbValue / rate.USD;
  return thbValue;
};

// Converts a single amount between currencies so switching the document's
// currency (or pulling in a THB-priced package while LAK/USD is selected)
// actually re-prices the number instead of just relabeling it.
// Mirrors backend/controllers/financial.js fromTHB — same rounding rule used
// for WhatsApp pickup/delivery money collection: LAK rounds to the nearest
// 1,000 since that's the smallest Lao banknote; THB/USD keep 2 decimal places.
export function convertAmount(value, fromCurrency, toCurrency, rate) {
  const num = Number(value) || 0;
  if (!rate || fromCurrency === toCurrency) return num;
  const converted = fromTHB(toTHB(num, fromCurrency, rate), toCurrency, rate);
  return toCurrency === "LAK" ? Math.round(converted / 1000) * 1000 : Math.round(converted * 100) / 100;
}
